import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDiscord, faYoutube, faTwitter, faTiktok, faInstagram } from '@fortawesome/free-brands-svg-icons';

const FooterContainer = styled.footer`
  background: rgba(10, 10, 10, 0.25);
  backdrop-filter: blur(8px);
  padding: 2rem;
  text-align: center;
  margin-top: auto;
  position: relative;
  box-shadow: 0 -2px 20px rgba(0, 0, 0, 0.2);
`;

const SocialLinks = styled.div`
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  margin-bottom: 1rem;
`;

const SocialIcon = styled.a`
  font-size: 1.5rem;
  color: #fff;
  transition: all 0.3s ease;
  
  &:hover {
    color: var(--accent-color);
    transform: translateY(-3px);
  }
`;

const Copyright = styled.p`
  color: #aaa;
  font-size: 0.9rem;
  font-family: 'Poppins', sans-serif;
  
  span {
    color: var(--primary-color);
    font-weight: bold;
    font-family: 'Poppins', sans-serif;
  }
  a {
    color: var(--primary-color);
    text-decoration: none;
    transition: all 0.3s ease;
    font-weight: bold;

    &:hover,
    &:focus {
      font-weight: bold;
      font-size: 1.1rem;
      color: var(--secondary-color);
    }
  }
`;

const Footer = ({ serverName, socialLinks }) => {
  // Function to get the correct icon based on the name
  const getIcon = (iconName) => {
    switch(iconName) {
      case 'faDiscord':
        return faDiscord;
      case 'faYoutube':
        return faYoutube;
      case 'faTwitter':
        return faTwitter;
      case 'faTiktok':
        return faTiktok;
      case 'faInstagram':
        return faInstagram;
      default:
        return faDiscord;
    }
  };

  return (
    <FooterContainer>
      <SocialLinks>
        {socialLinks && socialLinks.map((link, index) => (
          <SocialIcon 
            key={index} 
            href={link.url} 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon icon={getIcon(link.icon)} />
          </SocialIcon>
        ))}
      </SocialLinks>
      <Copyright>
        &copy; {new Date().getFullYear()} <span>{serverName}</span> Minecraft Server. All rights reserved.
        <br />
        Made by <a href="https://builtbybit.com/members/klever.426954/" target="_blank" rel="noopener noreferrer">Klever</a> on builtbybit.com <a href="https://builtbybit.com/members/klever.426954/" >❤︎</a>
      </Copyright>
    </FooterContainer>
  );
};

export default Footer;